import axios from 'axios';
import config from '@/config/env-constants';

export default {

    getRepair(param) {
        let url = `${config.cloudFunctionsBaseUrl}/getAssetRepairTask`;
        return axios.post(url, {
            currUserId: param.currUserId,
            filterBy: JSON.stringify(param.filterBy),
            view: param.view
        });
    },
    paginateRepairs(param) {
        let url = `${config.cloudFunctionsBaseUrl}/paginateAssetRepairTasks`;
        return axios.post(url, {
            currUserId: param.currUserId,
            filterBy: JSON.stringify(param.filterBy),
            view: param.view,
            page: param.page,
            limit: param.limit,
            startAt: param.startAt,
            direction: param.direction
        });
    },
    saveRepair(param) {
        let url = `${config.cloudFunctionsBaseUrl}/saveAssetRepairTask`;
        return axios.post(url, {
            currUserId: param.currUserId,
            repairTask: JSON.stringify(param.repair)
        });
    },
    markAsDoneRepair(param) {
        let url = `${config.cloudFunctionsBaseUrl}/markAsDoneAssetRepairTask`;
        return axios.post(url, {
            currUserId: param.currUserId,
            repairTask: JSON.stringify(param.repair)
        });
    },
    startRepair(param) {
        let url = `${config.cloudFunctionsBaseUrl}/startAssetRepairTask`;
        return axios.post(url, {
            currUserId: param.currUserId,
            repairTask: JSON.stringify(param.repair)
        });
    },
    cancelRepair(param) {
        let url = `${config.cloudFunctionsBaseUrl}/cancelAssetRepairTask`;
        return axios.post(url, {
            currUserId: param.currUserId,
            repairTask: JSON.stringify(param.repair)
        });
    },
}